import { FC } from 'react'
import { useAppConfig, useGetTranslations } from '@/root/shared-hooks'
import { RefundAmountInfoProps } from '@/root/shared-types'
import { ThreeDotsLoader } from '@/root/ui/tuuleliinid'

export const RefundAmountInfo: FC<RefundAmountInfoProps> = ({
  amount,
  formattedPercent,
  totalRefundAmount,
  isFetching,
}) => {
  const { getTranslation } = useGetTranslations()
  const { formatMoney } = useAppConfig()

  return (
    <div className="text-lg font-bold">
      <div className="flex justify-between">
        <div>{getTranslation('amountPaid')}</div>
        <div className="text-right">{isFetching ? <ThreeDotsLoader /> : formatMoney(amount)}</div>
      </div>
      <div className="my-4 flex justify-between">
        <div>{getTranslation('percentRefund')}</div>
        <div className="text-right">{isFetching ? <ThreeDotsLoader /> : formattedPercent}</div>
      </div>
      <div className="flex justify-between">
        <div className="text-error">{getTranslation('amountRefund')}</div>
        <div className="text-error text-right">{isFetching ? <ThreeDotsLoader /> : formatMoney(totalRefundAmount)}</div>
      </div>
    </div>
  )
}
